module.exports = __webpack_public_path__ + "img/custom-27.4063bc28.svg";